var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wf-modal wf-download-modal",
      class: "wf-modal-" + (_vm.open ? "active" : "inactive")
    },
    [
      _vm.open
        ? _c("div", { staticClass: "wf-modal-wrapper" }, [
            _c("div", { staticClass: "wf-modal-content p-0 bg-white d-flex" }, [
              _c(
                "div",
                { staticClass: "p-4" },
                [
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString["pdp.modal.download.header.title"]
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString[
                          "pdp.modal.download.header.subtitle"
                        ]
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.tabs, function(tab) {
                    return _c(
                      "a",
                      {
                        key: tab.name,
                        class: [
                          "text-link d-block mb-2",
                          _vm.selectedTab.name === tab.name ? "active" : ""
                        ],
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.selectTab(tab)
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticClass:
                            "png-icon png-icon-icons-glyph--k-play-carrot "
                        }),
                        _vm._v(
                          " \n            " +
                            _vm._s(tab.tabLinkText) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "download-tab-triangle" })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "p-4 bg-light wf-download-image-modal-content" },
                [
                  _c("wf-download-image-modal-tab-content", {
                    key:
                      _vm.selectedTab.name +
                      "-" +
                      _vm.roomScene.data.toString() +
                      "-" +
                      _vm.installationMethod.tricycleCode,
                    attrs: {
                      element: _vm.selectedTab,
                      "is-room-scene":
                        _vm.selectedTab.name ==
                        _vm.tabs[_vm.ROOMSCENE_TAB_INDEX].name,
                      "is-installation":
                        _vm.selectedTab.name ==
                        _vm.tabs[_vm.INSTALLATION_TAB_INDEX].name,
                      "default-item": _vm.getDefaultItem(
                        _vm.selectedTab.name,
                        _vm.roomScene,
                        _vm.installationMethod
                      )
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-secondary d-none modal-error-404" },
                [
                  _c("div", { staticClass: "modal-error-content" }, [
                    _c("span", {
                      staticClass:
                        "png-icon png-icon-icons-glyph--red-close-sqr-fill "
                    }),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {}, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$resourceString["pdp.modal.download.error"]
                          )
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "wf-modal-button-close btn button-full",
                  staticStyle: { right: "0px" },
                  attrs: { type: "button" },
                  on: { click: _vm.closeModal }
                },
                [
                  _c("span", {
                    staticClass: "png-icon png-icon-icons-symbols--k-txtclose ",
                    attrs: { "aria-label": "Close modal" }
                  })
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "wf-modal-lightbox" })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "wf-modal-loader d-none",
        attrs: { id: "wf-download-modal-spiner" }
      },
      [
        _c(
          "div",
          { staticClass: "spinner-border", attrs: { role: "status" } },
          [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }